/**
 * API client for cache management endpoints.
 * Routes: /api/mgmt/cache
 */

import { apiFetch } from './client';

export interface CacheStats {
  status: string;
  healthy?: boolean;
  cache_type?: string;
  [key: string]: unknown;
}

export async function getCacheStats(token: string): Promise<CacheStats> {
  return apiFetch<CacheStats>('/api/mgmt/cache', token);
}

export async function flushCache(token: string): Promise<{ message: string }> {
  return apiFetch<{ message: string }>('/api/mgmt/cache/flush', token, {
    method: 'POST',
  });
}
